import { classify } from 'sidecar-utilities'

export const overlayStyles = classify({
  color: 'color-overlay',
  position: 'fixed inset-0 z-[700]',
  animation: 'data-[state=open]:animate-overlay-show',
})

//controls styles for the dialog
export const alertStyles = classify({
  styles:
    'color-bgDefaultContainer elevation-2nd-floor rounded-xl focus:outline-none',
  width: 'w-[calc(100%-theme(spacing.8)-var(--safe-right)-var(--safe-left))]',
  maxWidth: 'max-w-120',
  //keeps the alert away from the screen's edges
  spacing: 'my-4',
  position: 'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
  // Same z-index as the overlay (see `overlayStyles`), NOT higher. Both dialogs
  // portal to <body>, so with equal z-indexes a later-opened alert/modal wins on
  // DOM order and its overlay paints above — and dims — the one beneath. A higher
  // value here let the underlying content out-rank the top overlay and show
  // through at full brightness.
  zIndex: 'z-[700]',
  // makes the text get stylized
  // will remove eventually
  temp: '!h-auto',
})

//alertPaddingX is used by header, body, and footer
const sharedAlertPaddingX = 'px-6 md:px-8'

export const alertHeaderFooterStyles = classify({
  sharedAlertPaddingX,
  alertPaddingY: 'py-4 md:py-6',
})

export const alertBodyStyles = sharedAlertPaddingX
